import { getFormattedDate } from "utils/formatDate";

const ProfilePredictionStatusTable = ({ items }) => {
  const getTagClass = (status) => {
    switch (status) {
      case "Event Pending":
        return "profile__table-col-status--pending";
      case "Resolved True":
        return "profile__table-col-status--resolved";
      case "Resolved False":
        return "profile__table-col-status--not-resolved";
      case "Processing":
        return "profile__table-col-status--processing";
      case "Counter":
        return "profile__table-col-status--counter";
      default:
        return "";
    }
  };

  return (
    <div className="profile__table profile__table--predictions">
        <ul className="profile__table-head">
          <li className="profile__table-col profile__table-col1">
          Prediction ID
          </li>
          <li className="profile__table-col profile__table-col2">
            Prediction Created
          </li>
          <li className="profile__table-col profile__table-col3">Event Date</li>
          <li className="profile__table-col profile__table-col4">Event Type</li>
          <li className="profile__table-col profile__table-col5">Identity</li>
          <li className="profile__table-col profile__table-col6">Event</li>
          <li className="profile__table-col profile__table-col7">Trigger</li>
          <li className="profile__table-col profile__table-col8">
            Prize Value
          </li>
          <li className="profile__table-col profile__table-col9">Status</li>
        </ul>
        {items.map((item) => (
          <ul className="profile__table-row" key={item.id}>
            <li className="profile__table-col profile__table-col1">
              #{item.id}
            </li>
            <li className="profile__table-col profile__table-col2">
              {getFormattedDate(item.created_at)}
            </li>
            <li className="profile__table-col profile__table-col3">
              {item.event_date}
            </li>
            <li className="profile__table-col profile__table-col4">
              {item.event_type}
            </li>
            <li className="profile__table-col profile__table-col5">
              {item.identity}
            </li>
            <li className="profile__table-col profile__table-col6">
              {item.event}
            </li>
            <li className="profile__table-col profile__table-col7">
              {item.trigger}
            </li>
            <li className="profile__table-col profile__table-col8">
              ${item.prize_value}
            </li>
            <li className="profile__table-col profile__table-col9">
              <span
                className={`profile__table-col-status ${getTagClass(
                  item.status
                )}`}
              >
                {item.status}
              </span>
            </li>
          </ul>
        ))}
      </div>
  );
};

export default ProfilePredictionStatusTable;
